import { render } from "./BaseFileUpload.vue?vue&type=template&id=50b35b80"
import script from "./BaseFileUpload.vue?vue&type=script&lang=js"
export * from "./BaseFileUpload.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "50b35b80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50b35b80', script)) {
    api.reload('50b35b80', script)
  }
  
  module.hot.accept("./BaseFileUpload.vue?vue&type=template&id=50b35b80", () => {
    api.rerender('50b35b80', render)
  })

}

script.__file = "src/ui/BaseFileUpload.vue"

export default script